export const redirectOnlineBankingQuery = {
  key: 'payments_return',
  value: 'onlinebanking',
};

export const redirectEWalletQuery = {
  key: 'payments_return',
  value: 'ewallet',
};

export const redirectPayPalQuery = {
  key: 'payments_return',
  value: 'paypal',
};

export const redirectQrisQuery = {
  key: 'payments_return',
  value: 'qris',
};

export const redirectFpsQuery = {
  key: 'payments_return',
  value: 'fps',
};

export const redirectFpxQuery = { key: 'payments_return', value: 'fpx' };

export const redirectCartidQuery = (cartId: string) => ({
  key: 'cartid',
  value: cartId,
});

export const site = 'seekjobs';
